import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0f2a407a&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f2a407a')) {
      api.createRecord('0f2a407a', component.options)
    } else {
      api.reload('0f2a407a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=0f2a407a&", function () {
      api.rerender('0f2a407a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/staffs/Index.vue"
export default component.exports